import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  Typography,
} from '@mui/material';

const RulesPage = () => {
  return (
    <Container maxWidth='sm' sx={{ mt: 3 }}>
      <Card>
        <CardHeader
          title='RULES'
          titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
        />
        <Divider />
        <CardContent>
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <Typography variant='h6'>WAGER</Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                A $50 wager must be sent to <b>danielayson@gmail.com</b> via
                e-Transfer or PayPal. Your account will be disabled until you
                stake your wager.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='h6'>PAYOUT</Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    $50 to each round winner (most points awarded in a round)
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>$50 to second place</Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    Winner takes the rest of the pot
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='h6'>HOW TO MAKE PICKS</Typography>
            </Grid>
            <Grid item>
              <Typography variant='body1'>
                <b>For each series, pick the following:</b>
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                <b>SCORE:</b> Guess a score that you think will most likely
                occur during a series. Points awarded each time it happens.
              </Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    5 points for a one goal difference, eg. 3 - 2
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    7 points for a two goal difference, eg. 4 - 2
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    10 points for a three or more goal difference, eg. 4 - 1
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                <b>GAME WINNER:</b> Select one player from each team that you
                think is likely to score a game winning goal. Points awarded
                each time it happens.
              </Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    5 points for a team's top regular season goal scorer
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    10 points for any Forward who is not the top goal scorer
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    15 points for any Defenseman who is not the top goal scorer
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                <b>NUMBER OF GAMES:</b> Guess how many games there will be in a
                series.
              </Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    5 points for a five or six game series.
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    10 points for a four or seven games series
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                <b>SERIES WINNER:</b> Guess which team will win their series
              </Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    5 points for selecting the top seed (whoever has home ice
                    advantage)
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    10 points for selecting the lower seed.
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='h6'>ROUND MULTIPLIER</Typography>
              <ul>
                <li>
                  <Typography variant='body2'>
                    First round points don’t multiply.
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    Second round points are multiplied by 2.
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    Third round points are multiplied by 4.
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    The Stanley Cup round points are multiplied by 8.
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item>
              <Typography variant='h6'>TIE BREAKER</Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                In the event of a tie (for overall standings or for a round) I
                will first compare points awarded for series winner. If there is
                still a tie then I will use number of games. Then game winner
                and then game scores.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                If there is a tie in overall standings I will accumulate these
                values from all picks. If there is a tie for a round then only
                points awarded in that round are used. For example:
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                Jane Smith
                <ul>
                  <li>50 points awarded for series winner</li>
                  <li>40 points awarded for number of games</li>
                  <li>40 points awarded for game winner</li>
                  <li>44 points awarded for game scores</li>
                </ul>
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                John Smith
                <ul>
                  <li>40 points awarded for series winner</li>
                  <li>20 points awarded for number of games</li>
                  <li>90 points awarded for game winner</li>
                  <li>24 points awarded for game scores</li>
                </ul>
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                Jane Smith wins the tie breaker because 50 points were awarded
                for series winner when John Smith was only awarded 40 points.
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default RulesPage;
